export enum EditTeamTeachersContext {
  FromGlobalCoursesPage = "FROM_GLOBAL_COURSES_PAGE",
  FromCoursePage = "FROM_COURSE_PAGE",
  FromPackagePage = "FROM_PACKAGE_PAGE",
}
